const LOCATION_API = 'https://smartazanclock.com';

const getBrowserTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch (error) {
        return 'UTC';
    }
};

const getDeviceCoordinates = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported'));
        return;
    }

    navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 30 * 60 * 1000
    });
});

const fetchLocation = async (url) => {
    const response = await fetch(url, { method: 'POST' });
    if (!response.ok) throw new Error(`Location request failed: ${response.status}`);
    return response.json();
};

const normalizeLocation = (data, fallback = {}) => ({
    address: data.address || fallback.address,
    lat: data.lat ?? fallback.lat,
    lng: data.lng ?? fallback.lng,
    timeZoneID: data.timeZoneID || fallback.timeZoneID || getBrowserTimeZone()
});

export const detectAutomaticLocation = async () => {
    try {
        const position = await getDeviceCoordinates();
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const fallback = {
            address: `${lat.toFixed(5)}, ${lng.toFixed(5)}`,
            lat,
            lng,
            timeZoneID: getBrowserTimeZone()
        };

        try {
            const coordinates = encodeURIComponent(`${lat},${lng}`);
            const data = await fetchLocation(`${LOCATION_API}/geolocation?address=${coordinates}`);
            return { source: 'device', locationSettings: normalizeLocation(data, fallback) };
        } catch (error) {
            return { source: 'device', locationSettings: fallback };
        }
    } catch (deviceLocationError) {
        const data = await fetchLocation(`${LOCATION_API}/iplocation`);
        return { source: 'ip', locationSettings: normalizeLocation(data) };
    }
};
